import { SearchProduct } from "@lib/clients/nelo-api-client"
import { getDiscountAmount, getPercentageDiff } from "@lib/util/get-product-price"

export const getPriceAndDiscounts = (product: SearchProduct) => {
  const hasFreeShipping = product.discounts?.find((d) => d.rule.type === "free_shipping")

  const originalPrice = product.price * 100
  const discountAmount = getDiscountAmount(originalPrice, product.discounts ? product.discounts : [])
  const calculatedPrice = originalPrice - discountAmount
  const percentageDiff = Math.floor(getPercentageDiff(originalPrice, calculatedPrice))

  return {
    hasFreeShipping,
    originalPrice,
    discountAmount,
    calculatedPrice,
    percentageDiff,
  }
}
